import type { ITradeRequest } from 'models/secondaryMarket';

export type SecondaryMarketTradeActions =
  | SecondaryMarketTradeRequested
  | SecondaryMarketTradeReceived
  | SecondaryMarketTradeFailed
  | SecondaryMarketTradeRejected;

/////////////////////////////////////////////
export function secondaryMarketTradeRequested(tabId: string, quoteId: string, request: ITradeRequest) {
  return {
    type: 'SECONDARY_MARKET_TRADE_REQUESTED' as const,
    tabId,
    request,
    quoteId,
  };
}

export type SecondaryMarketTradeRequested = ReturnType<typeof secondaryMarketTradeRequested>;

/////////////////////////////////////////////
export function secondaryMarketTradeReceived(tabId: string, quoteId: string, tradeDate: string) {
  return {
    type: 'SECONDARY_MARKET_TRADE_RECEIVED' as const,
    tabId,
    tradeDate,
    quoteId,
  };
}

export type SecondaryMarketTradeReceived = ReturnType<typeof secondaryMarketTradeReceived>;

/////////////////////////////////////////////

export function secondaryMarketTradeFailed(tabId: string, quoteId: string, error: string) {
  return {
    type: 'SECONDARY_MARKET_TRADE_FAILED' as const,
    tabId,
    error,
    quoteId,
  };
}
export type SecondaryMarketTradeFailed = ReturnType<typeof secondaryMarketTradeFailed>;

/////////////////////////////////////////////

export function secondaryMarketTradeRejected(tabId: string, quoteId: string, error: string) {
  return {
    type: 'SECONDARY_MARKET_TRADE_REJECTED' as const,
    tabId,
    error,
    quoteId,
  };
}
export type SecondaryMarketTradeRejected = ReturnType<typeof secondaryMarketTradeRejected>;
